import React from "react";

import { MathJaxUtil } from "@courses-pm2/mathjax-util-component";
import { ReactHtmlParser } from "@use/react-html-parser";

/**
 * Singleton instance of a parser that's configured to only allow simple,
 * unstyled html tags.
 */
const simpleHtmlParser = new ReactHtmlParser();

simpleHtmlParser.whitelistTags("sub", "sup", "em", "i", "strong", "b", "u", "br");
simpleHtmlParser.whitelistAttrs();

/**
 * Helper that'll safely parse some simple html tags, which Gyldendal's editors
 * have been allowed to enter in certain parts of the application.
 */
export function parseSimpleHtml(html: string): React.ReactNode {
    return React.createElement(
        MathJaxUtil,
        {},
        simpleHtmlParser.parseSync(html),
    );
}
